import * as Yup from "yup"
import _ from "lodash"

export default function validation_activity_length(field, acc) {
  const { field_name, field_validation } = field

  const isRequiredTxt =
    (field_validation.required && field_validation.required[1]) ||
    "Required field."

  return {
    [field_name]: Yup.number().when("activity_length_hours", {
      is:  (value) => value === 0, 
      then: Yup.number().moreThan(0, isRequiredTxt).required(isRequiredTxt),
    }),
    ...acc,
  }
}
